document.addEventListener('DOMContentLoaded', function(evt) {
  // Show selected variant features
  if (window.location.href.includes("/products")) {
    const widthButton = document.querySelector('.size-swatch');
    setTimeout(function () {
      console.log('width_button clicked!');
      widthButton.click();
    }, 1000);
  }
});